import {AbstractManager} from "./AbstractManager";
import listmanagerHtml from './listmanager.html?raw';

export let template = listmanagerHtml;

export class viewModel extends AbstractManager {
}
